var map = {
	"./#8BB4F3.png": 81676,
	"./#92ECCD.png": 24952,
	"./#92ECEC.png": 91134,
	"./#A2C3F6.png": 12037,
	"./#BBF3FC.png": 96614,
	"./#EFBACC.png": 77800,
	"./#F5E9DD.png": 74798,
	"./#F67848.png": 24359,
	"./#F7E4EA.png": 42687,
	"./#F9EFE5.png": 63496,
	"./#FFBDA5.png": 6534,
	"./#FFDBDD.png": 84026,
	"./#a2c6f6.png": 65109,
	"./#f67c48.png": 23149,
	"./#fae8d6.png": 61783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24513;